import { render, staticRenderFns } from "./CreditsUtilization.vue?vue&type=template&id=2cbf24fa&scoped=true&"
import script from "./CreditsUtilization.vue?vue&type=script&lang=js&"
export * from "./CreditsUtilization.vue?vue&type=script&lang=js&"
import style0 from "./CreditsUtilization.vue?vue&type=style&index=0&id=2cbf24fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf24fa",
  null
  
)

export default component.exports